export default {
  traitManager: {
    appendTo: '.traits-container',
    custom: true,
  },
}
